import Api from "./index"

export interface IChargeWalletPackage {
    amount: number;
    user_pan: string;
    second_password: string;
    cvv2: number;
    expire_year: number;
    expire_month: number;
    additional_data?: string;
    operator_type_id: number;
    charge_type_id: number;
    mobile_number: string;
    simcard_type_id?: number;
}

export const chargeWalletPackage = (data: IChargeWalletPackage) => Api.POST({url: "/v1/wallet_charge", data, hasErr: false})

export interface ISmartIpgCharge {
    package_id: number;
    package_title: string;
    amount: number;
    mobile_number: string;
    request_id?: string;
    type_operator_id: number;
    type_simcard_id: number;
    package_type_id: number;
    package_type_title: string;
    base_url: string;
}

export const SmartIpgChargeApi = (data: ISmartIpgCharge) => Api.POST({url: "/v1/smart_ipg_charge", data})